import { render } from "./BbafinanceView.vue?vue&type=template&id=5b16e11d"
import script from "./BbafinanceView.vue?vue&type=script&lang=js"
export * from "./BbafinanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__